import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { API } from '../lib/api';
import { formatDateTime } from '../lib/brand';

const CAT = {
  batterie: 'Batterie leer',
  reifen: 'Reifen beschädigt',
  motor: 'Motorproblem',
  startet_nicht: 'Startet nicht',
  sonstige: 'Sonstige',
};

export default function AdminBreakdowns() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const { data } = await API.get('/admin/breakdowns'); setItems(data); }
      finally { setLoading(false); }
    })();
  }, []);
  return (
    <div className="space-y-4" data-testid="admin-breakdowns">
      <h1 className="font-heading font-semibold text-2xl text-[hsl(var(--primary))]">Pannenhilfe</h1>
      <Card className="rounded-2xl border-slate-200">
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="admin-breakdowns-table">
              <thead className="bg-slate-50"><tr className="text-left text-slate-600"><th className="px-4 py-3">Kunde</th><th className="px-4 py-3">Telefon</th><th className="px-4 py-3">Kategorie</th><th className="px-4 py-3">Fahrzeug</th><th className="px-4 py-3">Erstellt</th></tr></thead>
              <tbody>
                {loading ? <tr><td colSpan={5} className="px-4 py-6 text-slate-500">Lade...</td></tr> : items.length === 0 ? <tr><td colSpan={5} className="px-4 py-6 text-slate-500">Keine Pannenhilfe-Anfragen.</td></tr> : items.map((b) => (
                  <tr key={b.id} className="border-t border-slate-100 hover:bg-slate-50">
                    <td className="px-4 py-3">{b.person.first_name} {b.person.last_name}</td>
                    <td className="px-4 py-3">{b.person.phone}</td>
                    <td className="px-4 py-3">{CAT[b.category] || b.category}</td>
                    <td className="px-4 py-3">{b.vehicle ? `${b.vehicle.make || ''} ${b.vehicle.model || ''} ${b.vehicle.license_plate || ''}`.trim() : '-'}</td>
                    <td className="px-4 py-3 text-slate-500">{formatDateTime(b.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
